// App context
import React from 'react';
import { getTumblerConfig, RegionInfo } from './appConfig';
import { ACCOUNTS_MAP, JUNO_BEHOLDERS_ACCOUNT_MAP } from './rootAccounts';
import {SDPDS_ACCOUNT_MAP} from './sdpdsAccounts';

export enum Stages {
  ALPHA = 'alpha',
  BETA = 'beta',
  GAMMA = 'gamma',
  PROD = 'prod',
}

/**
 * Public region names where AgentHawk is enabled in prod during the initial
 * rollout. Kept as an array so more regions can be added as the feature expands.
 */
export const AGENT_HAWK_PROD_PUBLIC_REGIONS: string[] = ["eu-west-3", "eu-west-1", "us-west-2", "us-east-2", "us-east-1", "eu-central-1", "eu-west-2", "eu-north-1", "ap-northeast-1", "ap-northeast-2", "ap-southeast-1", "ap-southeast-2", "ap-south-1", "ca-central-1", "sa-east-1"];
/**
 * Determine whether AgentHawk should be available for the given stage/region.
 *
 * @param stage  - The current deployment stage.
 * @param region - The current region info.
 * @returns true when AgentHawk should be shown for this stage/region.
 */
export const isAgentHawkEnabledForStageRegion = (stage: Stages, region: RegionInfo): boolean => {
  switch (stage) {
    case Stages.BETA:
    case Stages.GAMMA:
      return true;
    case Stages.PROD:
      return AGENT_HAWK_PROD_PUBLIC_REGIONS.includes(region.publicRegion);
    default:
      return false;
  }
};

export interface App {
  region: RegionInfo;
  timezone: string;
  setTimezone: Function;
  partition: string;
  stage: Stages;
  rootAccountId: string;
  [key: string]: any;
}

export const getInitialAppContext = () => {
  const config = getTumblerConfig();
  const regionInfo = config.current;
  const partition = config.current.partition;
  const stage = config.stage as Stages || Stages.BETA;

  return {
    region: regionInfo,
    timezone: 'utc',
    setTimezone: () => { },
    breadcrumbs: [],
    setBreadcrumbs: () => { },
    partition,
    stage,
    rootAccountId: ACCOUNTS_MAP[partition]?.[stage]?.[regionInfo.publicRegion] || ACCOUNTS_MAP.aws?.[stage]?.[regionInfo.publicRegion],
    junoBeholderAccountId: JUNO_BEHOLDERS_ACCOUNT_MAP[partition]?.[stage]?.[regionInfo.publicRegion] || JUNO_BEHOLDERS_ACCOUNT_MAP.aws?.[stage]?.[regionInfo.publicRegion],
    sdpdsAccountId: SDPDS_ACCOUNT_MAP[partition]?.[stage]?.[regionInfo.publicRegion] || SDPDS_ACCOUNT_MAP.aws?.[stage]?.[regionInfo.publicRegion],
    preferences: {
      humanFriendlyTime: true,
    },
  };
};

const AppContext = React.createContext<App>(getInitialAppContext());
export { AppContext };
